var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownpkg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4125 9.34623C13.3719 9.74506 13.0241 10.0359 12.6297 9.99641L6.96048 9.39816C6.56803 9.35661 6.28335 9.0014 6.32402 8.60048C6.36469 8.20164 6.71037 7.90875 7.10485 7.95029L11.068 8.36783L7.5156 3.90375L4.93519 6.04543C4.63221 6.29262 4.19096 6.24692 3.94085 5.94156L0.130223 1.14928C-0.0975199 0.818991 -0.0182167 0.366144 0.303064 0.133489C0.591809 -0.0742397 0.982226 -0.0368481 1.2242 0.226966L4.59155 4.46254L7.17399 2.32502C7.47493 2.07782 7.91619 2.12145 8.1663 2.42681L12.1701 7.45798L12.5788 3.40313C12.6195 3.00429 12.9692 2.71347 13.3617 2.75294C13.7541 2.79656 14.0368 3.15385 13.9961 3.55477L13.4125 9.34623Z",
    fill: "#84161D",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownpkg2);
export default __webpack_public_path__ + "static/media/downpkg2.6b2ddfd05a5a0fb84241cd79010e3271.svg";
export { ForwardRef as ReactComponent };